'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var ListItemWithIcon = require('../ListItemWithIcon/ListItemWithIcon.js');
var styledComponents = require('./styled-components.js');

var SubListItemWithIcon = function (props) {
    var rightIcon = props.rightIcon, clickHandler = props.clickHandler, text = props.text, _a = props.active, active = _a === void 0 ? false : _a;
    var Bullet = (React__default.createElement(styledComponents.BulletSpan, { "data-testid": 'bullet-icon', className: active ? 'active' : '' }, "\u2022"));
    return (React__default.createElement(styledComponents.SubListContainer, { className: active ? 'active' : '' },
        React__default.createElement(ListItemWithIcon, { leftIcon: Bullet, title: text, primaryText: text, handleClick: clickHandler, rightIcon: rightIcon })));
};

module.exports = SubListItemWithIcon;
